import React, { FC } from "react";
import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./landing.style.scss";

// type LnadingProps = {
//   setIsFirst: (value: boolean) => void;
// };
const Landing: FC = () => {
  const { Title } = Typography;
  // const token =
  //   "eyJhbGciOiJSUzI1NiIsImtpZCI6IjZFMzcyNjUzQ0I3NDIwM0Q0NTk5OUZGMDZEMEUxRTYzIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2NTM3OTY2OTUsImV4cCI6MTY4NTMzMjY5NSwiaXNzIjoiaHR0cDovL2FwaS5hYXNzdHRpaW5uLm9yZyIsImF1ZCI6IldNUyIsImNsaWVudF9pZCI6IldNU19Td2FnZ2VyX0FwaSIsInN1YiI6IjNhMDI0Y2Q4LWIzZGMtN2ZkMi1jZTA3LTcwNzQzOTJhOWNkZSIsImF1dGhfdGltZSI6MTY1Mzc5NjY5MywiaWRwIjoibG9jYWwiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9naXZlbm5hbWUiOiJhZG1pbiIsInVuaXF1ZV9uYW1lIjoiYWRtaW4iLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJhZG1pbiIsImdpdmVuX25hbWUiOiJhZG1pbiIsInJvbGUiOiJhZG1pbiIsInBob25lX251bWJlcl92ZXJpZmllZCI6IkZhbHNlIiwiZW1haWwiOiJhZG1pbkBhYnAuaW8iLCJlbWFpbF92ZXJpZmllZCI6IkZhbHNlIiwibmFtZSI6ImFkbWluIiwic2lkIjoiMzMyMjQ4NzVEQ0ZDRDM0QzRFNzFGMDI5QTkwMzhGNDUiLCJpYXQiOjE2NTM3OTY2OTUsInNjb3BlIjpbIldNUyJdLCJhbXIiOlsicHdkIl19.qk4dOseqKcWyA039NpYQIjLq1snG084czhiA_5NDCimb-X6z0f4BcEhG3S5s8_9bHtgjbbZ33Y79VkL-vOkWusqN6QhxbSEHuYVKCy9Yxm28GeSrK0gFLmHpQBJVD8P8oE5jkflDSQLJQiMqII7hFSGvnhY0xNpMVMSdgq_YsezZoOSJIoZ35Yrjmwt15T4RdYze7E7Vf-bCQAgJNfVJa0Hh9SfGxS0GtfkK8ZNWGnOrr4WOS5noC_w61hyRj1slxZQ_W_GSQV-BRfcZ7UjigASPckB7u8k5KcUX75BPYy-olAUX9RxNns-_enn7wBuSJcMHFVnPQIFElsz0nFsavw";
  // // const { setIsFirst }: any = props;
  // // const handleOk = () => {
  // //   localStorage.setItem("isFirtstTime", "true");
  // //   setIsFirst(false);
  // // };

  return (
    <>
      <div className="custom-landing">
        <div className="content" style={{ textAlign: "left" }}>
          <Title
            level={1}
            style={{ marginBottom: 0, fontWeight: "bold", fontSize: "70px" }}
            className="py-4"
          >
            <div style={{ color: "#fea34a" }}>AASSTTIINN</div>
            <hr/>
            <div style={{ color: "#4547fc" }}>WMS SERVICE</div>
            <div style={{ color: "#4547fc" }}>سرویس انبار داری</div>
          </Title>

          <p
            style={{
              lineHeight: "30px",
              width: "55%",
              fontSize: "18px",
              color: "#9d9d9d",
              paddingBottom: "30px",
            }}
          ></p>

          <button style={{ backgroundColor: "#fea34a", fontSize: "white" }}>
            <Link to="/login">
              <span style={{ color: "white" }}>
                <FormattedMessage id="landing.enter" />
              </span>
            </Link>
          </button>
        </div>
      </div>
    </>
  );
};

export default Landing;
